import Swal from 'sweetalert2';
import { getAxiosClient } from '~src/api';
import { onErrorShowMessage } from '~src/errors';
import { isLoggedUserGlobalEditor } from '~src/user';
import {
  disableLoaderInput,
  getMetadata,
  loadingBox,
} from '~loader/loader-utils';
import { getState } from '~src/state';
import { handleTabTemplates } from '~src/sidebar/index';

const saveTemplate = async (templateCategoryId) => {
  const httpClient = await getAxiosClient();

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const name = isGlobalEditor ? '' : 'Modello Personalizzato';

  const data = {
    name,
  };

  let tableName;

  const projectType = getState('selected.tipo');
  let templatesCategory;

  if (templateCategoryId) {
    templatesCategory = window.editorConfig.sidebarTemplatesCategories.items.find(
      (templateCategory) => templateCategory.objectId === templateCategoryId
    );
  } else {
    templatesCategory = getState('selected.templatesCategory');
  }

  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');

  if (templatesCategory.isGlobal) {
    data.editor_templates_categories_default_pointer =
      templatesCategory.objectId;
  } else {
    data.editor_templates_categories_pointer = templatesCategory.objectId;
  }

  if (isGlobalEditor) {
    data.editor_project_types_default_pointer = projectType.objectId;
    data.editor_project_formats_default_pointer = formatDefault.objectId;
    data.isGlobal = true;
    tableName = 'editor_templates_default';
  } else {
    if (projectType.isGlobal) {
      data.editor_project_types_default_pointer = projectType.objectId;
    } else {
      data.editor_project_types_pointer = projectType.objectId;
    }
    if (format && format.objectId) {
      data.editor_project_formats_pointer = format.objectId;
    }
    if (formatDefault && formatDefault.objectId) {
      data.editor_project_formats_default_pointer = formatDefault.objectId;
    }
    tableName = 'editor_templates';
  }

  data.metadata = getMetadata();
  if (templateCategoryId) {
    data.metadata.templatesCategoryName = templatesCategory.name;
  }

  const response = await httpClient.post(
    `${process.env.PARSE_API_URL}/${tableName}`,
    {
      data,
    }
  );

  return response.data.data;
};

const saveTemplatePages = async (templateId) => {
  const httpClient = await getAxiosClient();

  const data = {};

  let tableName;

  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const format = getState('selected.formato');
  const formatDefault = getState('selected.formatoDefault');

  if (format && format.objectId && format.isCustom) {
    data.editor_project_formats_pointer = format.objectId;
  }
  if (formatDefault) {
    data.editor_project_formats_default_pointer = formatDefault.objectId;
  }

  data.canvasJson = JSON.stringify({
    objects: [],
    background: '#ffffff',
  });
  data.order = 1;
  if (isGlobalEditor) {
    data.editor_templates_default_pointer = templateId;
    data.isGlobal = true;
    tableName = 'editor_templates_default_pages';
  } else {
    tableName = 'editor_templates_pages';
    data.editor_templates_pointer = templateId;
  }

  const response = await httpClient.post(
    `${process.env.PARSE_API_URL}/${tableName}`,
    {
      data,
    }
  );

  return response.data.data;
};

const saveTemplateAndPagesRelation = async (templateId, pagesIds) => {
  const httpClient = await getAxiosClient();

  let tableName;
  let relationClassName;
  let relationColumnName;
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  if (isGlobalEditor) {
    tableName = 'editor_templates_default';
    relationClassName = 'editor_templates_default_pages';
    relationColumnName = 'editor_templates_default_pages';
  } else {
    tableName = 'editor_templates';
    relationClassName = 'editor_templates_pages';
    relationColumnName = 'editor_templates_pages';
  }

  const url = `${process.env.PARSE_API_URL}/${tableName}/${templateId}`;
  const method = 'PUT';
  const data = {};

  data.relations = [
    {
      class: relationClassName,
      column: relationColumnName,
      toIds: pagesIds,
    },
  ];

  return httpClient({ url, method, data: { data }, responseType: 'json' });
};

export const createNewTemplate = async (templateCategoryId) => {
  disableLoaderInput();

  try {
    loadingBox('Creo il nuovo modello...');
    const template = await saveTemplate(templateCategoryId);
    const page = await saveTemplatePages(template.objectId);
    await saveTemplateAndPagesRelation(template.objectId, [page.objectId]);

    await handleTabTemplates(true);

    Swal.fire({
      title: 'Creato!',
      html:
        'Il nuovo modello &egrave; stato creato ed è ora pronto per essere utilizzato.',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
